import {
  calculateFreeTrialDaysLeft,
  isCoachConverted,
  isCoachFreeTrial,
} from "../../../../utils/user-helpers";
import { getRoleNameById } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import { CustomWorkflowsList } from "../components/CustomWorkflowsList";
import LearnWorkflowsList from "../components/LearnWorkflowsList";
import { customWorkflowsList } from "../data/customWorkflowsList";

const CustomWorkflows = (_, { locals }) => {
  const { activeUser, organizationOwner, organizationRoles, query, workflows } =
    locals;
  const roleName = !!activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
    : "Owner";
  const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";
  const notAbleToEdit =
    !!activeUser.organizationId && !!organizationOwner && !isAdminOrOwner;
  const isCoach =
    activeUser.permissions?.includes("coach") &&
    !(!organizationOwner && !isCoachConverted(activeUser));
  const isExpiredPull =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) < 1;
  const userToBindInformation =
    roleName === "Owner" ? activeUser : organizationOwner;
  const isPushCoach = Boolean(userToBindInformation.pushAccountInfo);

  const filteredWorkflows = workflows.filter((workflow) => {
    return workflow.access === query.access;
  });

  return (
    <main className="custom-workflows">
      <header>
        <hgroup className="mobile-hidden">
          <h3>Custom Workflows</h3>
          <p className="p4">
            Custom workflows are features you can add to your app to create more
            value for your users. Explore the options available below to begin
            building out custom features in your app.
          </p>
        </hgroup>
        <nav role="tablist">
          {isPushCoach && !notAbleToEdit && (
            <a
              href="/actions/refresh?access=push"
              aria-current={
                !query.access || query.access === "push" || undefined
              }
            >
              Subscriptions (PUSH)
            </a>
          )}
          {!!isCoach && !isExpiredPull && (
            <a
              href="/actions/refresh?access=pull"
              aria-current={query.access === "pull" || undefined}
            >
              Coaching (PULL)
            </a>
          )}
        </nav>
        {/* <ExploreSelector customWorkflowsList={customWorkflowsList} /> */}
      </header>
      <section>
        <LearnWorkflowsList
          customWorkflowsList={customWorkflowsList[query.access] || []}
          workflows={filteredWorkflows}
          access={query.access}
        />
        <CustomWorkflowsList workflows={filteredWorkflows} />
      </section>
    </main>
  );
};

export default CustomWorkflows;
